import React, { createContext, useContext, useState } from 'react'
import { type ArtCatalog } from '../ArtCollection.types'
import { initArtCatalog } from '../../../services/artCatalogService'
import useOnMount from 'hooks/useOnMount'
import { preloadArtworkThumbnails } from '../../../services/artCollectionService'

type ArtCollectionContextType = {
  catalog: ArtCatalog | null
}

const ArtCollectionContext = createContext<
  ArtCollectionContextType | undefined
>(undefined)

type Props = {
  children: React.ReactNode
}

export function ArtCollectionProvider({ children }: Props) {
  const [catalog, setCatalog] = useState<ArtCatalog | null>(null)

  useOnMount(() => {
    async function loadCatalog() {
      const catalog = await initArtCatalog()
      if (catalog) {
        setCatalog(catalog)
        preloadArtworkThumbnails(Object.values(catalog)[0])
      }
    }

    loadCatalog()
  })

  return (
    <ArtCollectionContext.Provider value={{ catalog }}>
      {children}
    </ArtCollectionContext.Provider>
  )
}

export function useArtCollection() {
  const context = useContext(ArtCollectionContext)
  if (!context) {
    throw new Error(
      'useArtCollection must be used within an ArtCollectionProvider'
    )
  }
  return context
}
